///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../filter-templates/point-promotions.filter.ts"/>
///<reference path="../collections/report-users.collection.ts"/>

module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class CSEServicesWithCategoriesDataTemplate extends DataTemplateBase implements IDataTemplate {
        protected serviceCategories: ServiceCategoriesCollection;
        protected services: CSEServicesCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;
        public totalParentSelectedMessage: string;

        get collection() {
            return this.serviceCategories;
        }

        get totalSelectedCount(): number {
            return this.services.value.length;
        }

        get totalParentSelectedCount(): number {
            return this.serviceCategories.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this.serviceCategories = new ServiceCategoriesCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });
            this.services = new CSEServicesCollection(this.model[properties[1]], [], {
                criteria: options.criteria,
                smartMoverHidden: () => this.smartMoverHidden
            });

            this.services.setParentCollection(this.serviceCategories, CoreServiceToCategoryStrategy);

            this.filters = [
                new ActiveInactiveFilter({hideInactiveLabel: 'LABEL_HIDE_INACTIVE_SERVICES'}, this)
            ];
            this.services.addFilters(...this.filters as IInteractiveFilter[]);

            this.title = 'LABEL_SERVICE_CATEGORY_SERVICE';
            this.allSelectedLabel = 'LABEL_ALL_SERVICES';
            this.totalSelectedMessage = 'LABEL_TOTAL_SERVICES_SELECTED';
            this.totalParentSelectedMessage = 'LABEL_TOTAL_SERVICE_CATEGORIES_SELECTED';
        }

        setWatchers(scope: angular.IScope) {
            super.setWatchers(scope);

            this.services.setWatchers(scope);
        }

        onHideToggle(hidden: boolean): void {
            this.smartMoverHidden = hidden;
        }
    }
}
